import { useRequest } from 'ahooks';
import { Image, Modal } from 'antd';
import { oSSController } from '../api';
import { useCompany } from '../hooks/company';
import { useRef, useState } from 'react';

interface VideoPreviewWithThumbnailProps {
  ossKey: string;
  thumbnailUrl?: string;
  width?: number;
  height?: number;
}

const VideoPreviewWithThumbnail = ({
  ossKey,
  thumbnailUrl,
  width = 320,
  height = 180,
}: VideoPreviewWithThumbnailProps) => {
  const { id: companyId } = useCompany();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const { data: videoUrl } = useRequest(
    () => {
      return oSSController.getOSSUrl(companyId, ossKey);
    },
    {
      refreshDeps: [companyId, ossKey],
    },
  );

  const handlePreviewClick = () => {
    setIsModalOpen(true);
  };

  const videoRef = useRef<HTMLVideoElement>(null);

  const handleModalClose = () => {
    if (videoRef.current) {
      videoRef.current.pause();
    }
    setIsModalOpen(false);
  };

  return (
    <>
      <div
        style={{
          cursor: 'pointer',
          overflow: 'hidden',
          height: 320,
          position: 'relative',
        }}
        onClick={handlePreviewClick}
      >
        {thumbnailUrl ? (
          <Image
            preview={false}
            src={thumbnailUrl}
            style={{
              width: '100%',
              height: '100%',
              margin: '0 auto',
              objectFit: 'contain',
            }}
          />
        ) : (
          <video
            src={videoUrl}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
            }}
          />
        )}
        <div
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: '48px',
            height: '48px',
            borderRadius: '50%',
            background: 'rgba(0, 0, 0, 0.6)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <svg viewBox="0 0 24 24" width="24" height="24" fill="#ffffff">
            <path d="M8 5v14l11-7z" />
          </svg>
        </div>
      </div>

      <Modal
        open={isModalOpen}
        onCancel={handleModalClose}
        footer={null}
        closeIcon={null}
        width="80vw"
        style={{ maxWidth: '1200px' }}
        bodyStyle={{ padding: '24px', background: '#000' }}
        centered
      >
        <video
          controls
          autoPlay
          style={{
            width: '100%',
            height: 'calc(80vh - 48px)',
            objectFit: 'contain',
          }}
          ref={videoRef}
          src={videoUrl}
        />
      </Modal>
    </>
  );
};

export default VideoPreviewWithThumbnail;
